import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import "./informes.scss";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {xcService} from "../../../_services/xcService";
import {useLocation} from "react-router-dom";

import {isBrowser} from 'react-device-detect';

import InformeCervoPDF from "./cervo.pdf.page";
import * as _ from "lodash";
import endpoint from "shared/endpoints";

function InformeCervoSimple(props) {
    const {search} = useLocation();
    const [answers, setAnswers] = useState();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentProfile, setStudentProfile] = useState(null);
    const [studentArea, setStudentArea] = useState();
    const year = +new URLSearchParams(search).get('year');
    const [studentHistory, setStudentHistory] = useState();

    useEffect(() => {

        const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll('CERVO', {query: {year}}) : `/v1/student/${studentUid}/answers/CERVO?year=${year}`;
        xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));

        const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
        xcService.getToken(areaCevoPath).then(({data}) => {

            setStudentArea(data.data)
        });

    }, []);


    const getHistory = () => {
        if (studentUid){

            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => {
                    setStudentHistory(data.data)
                    let mStudentProfile = studentProfile;
                    mStudentProfile.course.id = data.data.course.id;
                    mStudentProfile.course.name = data.data.course.name;
                    setStudentProfile(mStudentProfile);
                })

        }
    }

    useEffect(() => {
        if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
            .then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            })
        else {
            //setStudentProfile(localOrSessionStore({key: variables.USER}))

            xcService.getToken('/v1/me').then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            });

        }
    }, [studentUid]);


    return (user &&
        <div className={"container dasboard-informes"}>
            <div style={{
                width: "100%", height: "100%"
            }}>
                <>
                        {studentProfile && answers && studentArea &&
                            <InformeCervoPDF
                                studentHistory={studentHistory} forDownload={isBrowser ? true : false} props={props} studentProfile={studentProfile}
                                             answers={answers}
                                             studentArea={studentArea}/>}
                </>
            </div>
        </div>
    )
}

export default withTranslation()(InformeCervoSimple);


